var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11V22.5H7.81C4.17 22.5 2 20.33 2 16.69V11H11.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11V16.69C22 20.33 19.83 22.5 16.19 22.5H12.75V11H22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.31V9.5H2V8.31C2 4.67 4.17 2.5 7.81 2.5H16.19C19.83 2.5 22 4.67 22 8.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridBold);
export default __webpack_public_path__ + "static/media/grid-bold.beaa277ce6b37c323ee59c74962820c6.svg";
export { ForwardRef as ReactComponent };